<div [attr.id]="attrId" style="position: relative"></div>
<!-- <div id="gaugeArea"></div> -->
